// extracted by mini-css-extract-plugin
module.exports = {"root":"fix-comunidades-detalles-inscritos_root__1CQIJ","SectionTitle":"fix-comunidades-detalles-inscritos_SectionTitle__2yko4"};